/**
 * Speedcargo Theme - Default Speedcargo Technologies Theme
 * Professional dark theme with neutral grays and blue accents
 */

import type { ThemeConfig } from 'antd';

/**
 * Speedcargo Theme Color Tokens
 */
export const SPEEDCARGO_THEME_TOKENS = {
	// Base colors
	fontSize: 10,
	fontFamily:
		"'Avenir Next LT Pro', AvenirNextLTPro, 'Avenir Next', Avenir, -apple-system, sans-serif",
	colorBgBase: '#000000',
	colorTextBase: '#ffffff',
	colorBorder: '#333333',
	controlOutline: 'transparent',
	controlOutlineWidth: 0,

	// Primary colors - Professional Blue
	colorPrimary: '#1890ff',
	colorPrimaryHover: '#40a9ff',
	colorPrimaryActive: '#096dd9',

	// Link colors
	colorLink: '#1890ff',
	colorLinkHover: '#40a9ff',
	colorLinkActive: '#096dd9',

	// Layout
	borderRadius: 0,
} as const;

/**
 * Speedcargo Theme Component Customizations
 */
export const SPEEDCARGO_COMPONENTS: ThemeConfig['components'] = {
	Button: {
		// Primary button style
		colorPrimary: '#475359',
		colorTextLightSolid: '#ffffff',
		primaryShadow: '0 4px 8px rgba(0,0,0,0.3)',
		colorPrimaryHover: '#5c6a75',
		colorPrimaryActive: '#3b454d',

		// Default button style
		colorBgContainer: '#484C50',
		// colorBorder: '#5a5f63',
		colorText: '#ffffff',
		defaultHoverBg: '#5a5f63',
		defaultHoverColor: '#ffffff',
		defaultActiveBg: '#3c3f42',
	},
	Modal: {
		contentBg: '#232323',
		headerBg: '#232323',
		titleColor: '#ffffff',
		colorText: '#ffffff',
	},
	Input: {
		colorBgContainer: '#484C50',
		colorText: '#ffffff',
		colorBorder: '#484C50',
		activeShadow: '0 0 0 2px rgba(71,83,89,0.4)',
		colorTextPlaceholder: '#bfbfbf',
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	Select: {
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	DatePicker: {
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	Form: {
		labelColor: '#ffffff',
		colorText: '#ffffff',
	},
	Table: {
		colorBgContainer: '#0a0c0d',
		headerColor: '#bfc7cf',
	},
	Card: {
		colorBgContainer: '#232323',
	},
	Checkbox: {
		colorPrimary: '#808080',
		colorPrimaryHover: '#696969',
		borderRadius: 4,
		colorWhite: '#000000',
	},
};

/**
 * Speedcargo Layout Colors
 */
export const SPEEDCARGO_LAYOUT_COLORS = {
	navbar: {
		background: '#1F1F1F',
		height: '50px',
		boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
	},
	content: {
		background: '#0A0C0D',
		marginTop: 35,
		paddingVertical: 24,
	},
	layout: {
		background: '#0A0C0D',
		minHeight: '100vh',
	},
} as const;

export const COLORS = {
	orange: '#1f2937',
	blue: '#f59e0b',
	dark: '#3b82f6',
} as const;
